import React, { useEffect, useRef, useState } from "react";
import jsQR from "jsqr";

const JsQrReader = ({ onResult }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const startCamera = async () => {
      try {
        // Solicitar acceso a la cámara con resolución reducida
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "environment",
            width: { ideal: 640 }, // Limitar la resolución para mejorar el rendimiento
            height: { ideal: 480 },
          },
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          requestAnimationFrame(tick); // Iniciar el bucle de procesamiento
        }
      } catch (err) {
        setError(err); // Manejar errores de acceso a la cámara
      }
    };

    let frameCount = 0;

    const tick = () => {
      frameCount++;
      // Procesar solo cada 2 fotogramas para reducir la carga
      if (frameCount % 2 === 0) {
        if (videoRef.current && videoRef.current.readyState === videoRef.current.HAVE_ENOUGH_DATA) {
          const canvas = canvasRef.current;
          const video = videoRef.current;

          // Reducir el tamaño del canvas para mejorar el rendimiento
          canvas.width = 200;
          canvas.height = 200;

          const ctx = canvas.getContext("2d");

          // Definir una región central más pequeña para escanear
          const regionWidth = 200;
          const regionHeight = 200;
          const x = (video.videoWidth - regionWidth) / 2;
          const y = (video.videoHeight - regionHeight) / 2;

          // Dibujar solo la región central del video en el canvas
          ctx.drawImage(video, x, y, regionWidth, regionHeight, 0, 0, canvas.width, canvas.height);

          // Obtener los datos de la imagen para procesar el QR
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const code = jsQR(imageData.data, imageData.width, imageData.height);

          // Si se detecta un código QR, enviar el resultado
          if (code) {
            onResult({ text: code.data });
          }
        }
      }
      requestAnimationFrame(tick); // Continuar el bucle
    };

    startCamera(); // Iniciar la cámara

    // Limpiar al desmontar el componente
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, [onResult]);

  return (
    <div>
      {/* Video oculto para capturar la cámara */}
      <video ref={videoRef} style={{ display: "none" }} />

      {/* Canvas para renderizar y procesar la imagen */}
      <canvas
        ref={canvasRef}
        className="size-96 mx-auto"
        style={{ willChange: "transform" }} // Optimizar renderizado
      />

      {/* Mostrar errores si ocurren */}
      {error && <p>Error: {error.message}</p>}
    </div>
  );
};

export default JsQrReader;